export function isPlaceInactive(place) {
  return place?.active === false || place?.active === 0 || place?.active === '0';
}
